// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fj-0";
export var actionModalContentContainer = "_fj-1";
export var createTagButton = "_fj-2";
export var footerContainer = "_fj-7";
export var fullWidthDivider = "_fj-3";
export var hasCreateTagButton = "_fj-4";
export var noCreateTagButton = "_fj-5";
export var tagsContainer = "_fj-6";
export var tagsModalContentContainer = "_fj-8";